/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Launch_Free_StorefrontInputs */

const en_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Free Storefront`)
};

const es_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzar tienda gratis`)
};

const fr_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer une vitrine gratuite`)
};

const de_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Storefront starten`)
};

const ja_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ストアフロントを立ち上げる`)
};

const zh_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动免费店铺`)
};

const ar_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق واجهة متجر مجانية`)
};

const id_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan Etalase Gratis`)
};

const it_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia Vetrina Gratuita`)
};

const ru_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустить бесплатную витрину`)
};

const pt_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançar Vitrine Grátis`)
};

const ko_launch_free_storefront = /** @type {(inputs: Launch_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 스토어 런칭하기`)
};

/**
* | output |
* | --- |
* | "Launch Free Storefront" |
*
* @param {Launch_Free_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const launch_free_storefront = /** @type {((inputs?: Launch_Free_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Launch_Free_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_launch_free_storefront(inputs)
	if (locale === "es") return es_launch_free_storefront(inputs)
	if (locale === "fr") return fr_launch_free_storefront(inputs)
	if (locale === "de") return de_launch_free_storefront(inputs)
	if (locale === "ja") return ja_launch_free_storefront(inputs)
	if (locale === "zh") return zh_launch_free_storefront(inputs)
	if (locale === "ar") return ar_launch_free_storefront(inputs)
	if (locale === "id") return id_launch_free_storefront(inputs)
	if (locale === "it") return it_launch_free_storefront(inputs)
	if (locale === "ru") return ru_launch_free_storefront(inputs)
	if (locale === "pt") return pt_launch_free_storefront(inputs)
	return ko_launch_free_storefront(inputs)
});